import clsx from "clsx";
import { ButtonHTMLAttributes, PropsWithChildren } from "react";
import { Favorite } from "nvs-ds-icons/react/core";
import { IconContainer } from "@/src/components/icons/components/IconContainer";

interface FavoriteButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export function FavoriteButton({
  className,
  active,
  ...props
}: PropsWithChildren<FavoriteButtonProps>) {
  return (
    <button
      className={clsx(
        "betterhover:hover:text-green-500 flex-shrink-0 flex-grow-0",
        "disabled:text-gray-500 disabled:pointer-events-none",
        className,
      )}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
      {...props}
    >
      <IconContainer>
        <Favorite className={clsx(active && "fill-green-500 text-green-500")} />
      </IconContainer>
    </button>
  );
}
